import { render } from "./ShowTypeMarchandise.vue?vue&type=template&id=56fbe098"
import script from "./ShowTypeMarchandise.vue?vue&type=script&lang=js"
export * from "./ShowTypeMarchandise.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__